// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__("./src/index.tsx");
// This entry module used 'module' so it can't be inlined
